angular.module("providers")

    .controller("ProvidersListCtrl", ['LoginService', '$state', '$rootScope', '$scope', 'Restangular', 'gridService', '$filter', '$translate', 'modalService',
        function (LoginService, $state, $rootScope, $scope, Restangular, gridService, $filter, $translate, modalService) {

            $scope.allowWrite = LoginService.permissionExist("PROVIDERS_WRITE");
            $rootScope.title = $filter('translate')('providers.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('providers.title') }
            ];

            $scope.gridOptionsProviders = {
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('providers.name'), enableFiltering: true, enableHiding: false },
                    { name: 'contact', displayName: $filter('translate')('providers.contact'), enableFiltering: true, enableHiding: false },
                    { name: 'mail', displayName: $filter('translate')('providers.mail'), enableFiltering: true, enableHiding: false },
                    { name: 'phone', displayName: $filter('translate')('providers.phone'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('providers.button_edit'), action: 'ui-sref="providers.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('providers.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    return Restangular.all('providers').getList(options)
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("providers.edit", { id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('providers.button_delete'),
                    message: $filter('translate')('providers.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Providers', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('providers.delete_success'));
                            $scope.gridOptionsProviders.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };


    }]);